import { render } from "./UiMultiselect.vue?vue&type=template&id=0efbebc1&ts=true"
import script from "./UiMultiselect.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiMultiselect.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiMultiselect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0efbebc1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0efbebc1', __exports__)) {
    api.reload('0efbebc1', __exports__)
  }
  
  module.hot.accept("./UiMultiselect.vue?vue&type=template&id=0efbebc1&ts=true", () => {
    api.rerender('0efbebc1', render)
  })

}


export default __exports__